import { GET } from 'shared/utils/ajax';

const path = '/rest/media/dictionary';

/**
 * 단어 검색
 * @param {string} word
 */
export const getSearchWord$ = word => GET(`${path}/${word}`);
